import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useBrandName } from '../../../hooks';
import {
	AppState,
	AppThunkDispatch,
	Bundle,
	Project,
	ProjectActions,
	projectCreate,
	projectUpdate
} from '../../../redux';
import { IProjectEditDialogProps, ProjectEditDialog } from '../../organisms';

export interface ISaveDialogOwnProps {
	mapId?: string;
	projectTitle?: string;
	closeSaveDialog: () => void;
}

export interface ISaveDialogStateProps {
	project?: Project;
	updateProject: (project: Project, mapId?: string) => void;
	createProject: (
		project: Project,
		brandName: string,
		mapId?: string
	) => void;
}

function SaveDialogView(
	props: ISaveDialogOwnProps & ISaveDialogStateProps
): ReactElement {
	const {
		mapId,
		projectTitle,
		project,
		createProject,
		updateProject,
		closeSaveDialog
	} = props;
	const brandName: string = useBrandName();
	const { t } = useTranslation(['general', 'project']);

	const saveDialogState: IProjectEditDialogProps = {
		title: projectTitle || '',
		dialogTitle: t('project:saveMap'),
		message: t('project:saveMapText', { brandName }),
		bundles: project?.bundles || [],
		entityName: 'map',
		open: true,
		onClose: closeSaveDialog,
		onSave: saveProject
	};

	function saveProject(title: string, bundles: Bundle[]) {
		if (!project) return;

		const projectToSave: Project = {
			...project,
			title,
			bundles
		};

		if (project.id) {
			updateProject(projectToSave, mapId);
		} else {
			createProject(projectToSave, brandName, mapId);
		}
	}

	return (
		<>
			{saveDialogState.open && <ProjectEditDialog {...saveDialogState} />}
		</>
	);
}

function mapStateToProps(state: AppState) {
	return {
		project: state.project.present.project
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<ProjectActions>) {
	return {
		createProject: (project: Project, brandName: string, mapId?: string) =>
			dispatch(projectCreate(project, brandName, mapId)),
		updateProject: (project: Project, mapId?: string) =>
			dispatch(projectUpdate(project, mapId))
	};
}

export const SaveDialog = connect(
	mapStateToProps,
	mapDispatchToProps
)(SaveDialogView);
